import { render } from "./SessionExpiryWarning.vue?vue&type=template&id=d109fe12&scoped=true"
import script from "./SessionExpiryWarning.vue?vue&type=script&lang=js"
export * from "./SessionExpiryWarning.vue?vue&type=script&lang=js"

import "./SessionExpiryWarning.vue?vue&type=style&index=0&id=d109fe12&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src723/src/github.com/aqfer/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d109fe12"]])

export default __exports__